module.exports = __webpack_public_path__ + "static/media/inside_mur.a504018b.png";